import React from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { Notification, TypographyBody, WarningIcon } from '@honeycomb/ui-core';
export function HotelChangeFlightError() {
    const { resourceStrings: { CHANGE_FLIGHT_ERROR_HEADING, CHANGE_FLIGHT_ERROR_BODY }, } = useGlobalContext();
    return (React.createElement(Notification, { color: "warning", icon: React.createElement(WarningIcon, null) },
        React.createElement(TypographyBody, { "data-id": "flight-retry-heading", weight: "bold" }, CHANGE_FLIGHT_ERROR_HEADING),
        React.createElement(TypographyBody, null, CHANGE_FLIGHT_ERROR_BODY)));
}
